import React from 'react';
import {
  MapContainer,
  TileLayer,
  Polyline,
  Marker,
  Popup,
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix default marker icon issue in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const RouteMap = ({ coordinates }) => {
  if (!coordinates) {
    return <div>No coordinates to display.</div>;
  }

  let parsedCoords = [];

  // Handle single point like [lat, lng, alt]
  if (Array.isArray(coordinates) && typeof coordinates[0] === 'number') {
    const [lat, lng] = coordinates;
    parsedCoords = [[lat, lng]];
  } else if (Array.isArray(coordinates)) {
    parsedCoords = coordinates
      .map((point) => {
        if (typeof point === 'string') {
          const [lat, lng] = point.split(',').map(Number);
          return [lat, lng];
        } else if (
          typeof point === 'object' &&
          point.latitude !== undefined &&
          point.longitude !== undefined
        ) {
          return [point.latitude, point.longitude];
        } else if (Array.isArray(point) && point.length >= 2) {
          const [a, b] = point;
          if (Math.abs(a) <= 90 && Math.abs(b) <= 180) {
            return [a, b];
          } else if (Math.abs(b) <= 90 && Math.abs(a) <= 180) {
            return [b, a];
          }
        }
        return null;
      })
      .filter(Boolean);
  }

  if (parsedCoords.length === 0) {
    return <div>Invalid coordinates format.</div>;
  }

  const start = parsedCoords[0];
  const end = parsedCoords[parsedCoords.length - 1];

  return (
    <MapContainer
      center={start}
      zoom={10}
      scrollWheelZoom={true}
      style={{ height: '500px', width: '100%' }}
    >
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {/* Blue line if more than one point */}
      {parsedCoords.length > 1 && (
        <Polyline positions={parsedCoords} color="blue" />
      )}

      {/* Start Marker */}
      <Marker position={start}>
        <Popup>Start</Popup>
      </Marker>

      {/* End Marker (only if different from start) */}
      {parsedCoords.length > 1 && (
        <Marker position={end}>
          <Popup>End</Popup>
        </Marker>
      )}
    </MapContainer>
  );
};

export default RouteMap;
